import { RIGHTSHOLDER_GROUP, RIGHTSHOLDER_VALIDATION_GROUP_STATUSES } from '@Const/rightsholder-statuses'

export const generateRightsholderPaginationStatus = (
    rightsholderStatus: string | number[] | undefined
): number[] | undefined => {
    let newStatus
    switch (rightsholderStatus) {
        case RIGHTSHOLDER_GROUP.all:
            newStatus = undefined
            break
        case RIGHTSHOLDER_GROUP.done:
        case RIGHTSHOLDER_GROUP.allDone:
            newStatus = RIGHTSHOLDER_VALIDATION_GROUP_STATUSES.done
            break
        case RIGHTSHOLDER_GROUP.pending:
        case RIGHTSHOLDER_GROUP.allPending:
            newStatus = RIGHTSHOLDER_VALIDATION_GROUP_STATUSES.pending
            break
        case RIGHTSHOLDER_GROUP.failed:
            newStatus = RIGHTSHOLDER_VALIDATION_GROUP_STATUSES.failed
    }
    return newStatus
}
